import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { getSessionV2 } from "../../../../../redux/actions/skill";
import { getCookie } from "../../../../../common/cookie_helper";
import Loader from "../../../../../components/loader";

const CreateV2skills = () => {
  const params = useParams();
  const dispatch = useDispatch();
  // const urlParams = params.id.split("&");
  // const skillName = urlParams[0];

  // const skillId = urlParams[2];
  // const agentId = urlParams[1];

  const iframeRef = useRef(null);
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const url = window.location.href;

  const urlPath = new URL(url).pathname;
  const pathParts = urlPath.split("/").filter((part) => part);
  const [, , , skillNameAgentId] = pathParts;
  const [extractedSkillName, agentId, skillId] = skillNameAgentId.split("&");
  const skillName = decodeURIComponent(extractedSkillName);

  const urlParams = new URLSearchParams(new URL(url).search);
  const draftSkillId = urlParams.get("draftId");
  const orgId = urlParams.get("orgId");

  const checkSession = async () => {
    setIsLoading(true);
    await dispatch(getSessionV2());
    setIsLoading(false);
  };

  useEffect(() => {
    checkSession();
    return () => {};
  }, []);

  return (
    <div className="v2-frame">
      {isLoading ? (
        <Loader
          styles={{ width: "80px", margin: "auto" }}
          root={{ display: "flex" }}
        />
      ) : (
        <iframe
          // onLoad={handleIframeLoad}
          ref={iframeRef}
          title="Supervity AI"
          id="v2Frame"
          src={`${process.env.REACT_APP_V2_URL}/u/agents/${skillName}-${agentId}/edit/skills/automation/${skillId}?draftId=${draftSkillId}&orgId=${orgId}`}
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
    </div>
  );
};

export default CreateV2skills;
